import React, { useEffect } from 'react'
import useMapaCarga from './MapaCargaHook'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  DateTime,
  PageHeader,
  Periodo,
  ThreeDots,
  CustomMultiSelect,
} from '../../../../components'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { isRouteAllowed } from '../../../../services/permission/menus'
import OrdemCarregamentoModal from './OrdemCarregamentoModal'
import ObservacoesModal from './ObservacoesModal'
import { SplitButton } from 'primereact/splitbutton'
import { useMapaCargaContext } from '../../../../contexts/EntregaContext'

function MapaCarga({ history, dispatch, selectedTp }) {
  const { mapaCargaContext, setMapaCargaContext } = useMapaCargaContext()
  const { state, localDispatch } = useMapaCarga(mapaCargaContext.selectedPeriodo)

  useEffect(() => {
    localDispatch.fetchVeiculosParaEmissaoMapaCarga(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
  }, [selectedTp])

  useEffect(() => {
    setMapaCargaContext(prev => ({
      ...prev,
      selectedPeriodo: state.periodo,
    }))
  }, [state.periodo])

  useEffect(() => {
    if (state.loadingMessage) {
      dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  const splitButtonsItems = [
    {
      label: '02. Mapa de Entrega por Identificador ',
      command: () =>
        localDispatch.onBtnEmitirMapaEntregaIdentificadorClick(
          state.fleets.filter(f => f.selected),
          selectedTp,
        ),
    },
    {
      label: '03. Mapa de Entrega com Picking',
      command: () =>
        localDispatch.onBtnEmitirMapaEntregaPickingClick(
          state.fleets.filter(f => f.selected),
          selectedTp,
        ),
    },
  ]

  const header = (
    <CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange}>
      <div style={{ paddingLeft: '4px', display: 'inline' }}>
        <Btn onClick={() => localDispatch.onBtnExportarExcelClick(state.fleets)}>Exportar</Btn>
      </div>
    </CustomDataTableHeader>
  )

  const qteSkuBodyTemplate = e => {
    return e.qte_sku.toFixed(2)
  }

  // Render
  return (
    <>
      <PageHeader>3.5 - Emitir Mapa de Carga / Entrega</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onVoltar={history.goBack} showBtnNovo={false}>
          <div className="p-grid">
            <div className="p-col-3">
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>
                Data Prevista da Rota:
              </label>
              <Periodo
                periodoInicial={state.periodo.dataInicial}
                periodoFinal={state.periodo.dataFinal}
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.onPesquisar(selectedTp, pInicial, pFinal)
                }
              />
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-4">
              <CustomMultiSelect
                marginTop={9}
                filter={true}
                optionLabel="label"
                options={state.expectedDates}
                value={state.selectedFleets}
                label="Filtre pela Data Prevista de Entrega:"
                onChange={localDispatch.onMultiDateFilterChange}
              />
            </div>

            <div className="p-col-8">
              <div style={{ marginTop: '1.8rem' }}>
                <div
                  style={{
                    display: 'inline-block',
                    marginRight: '0.5rem',
                    marginBottom: '0.5rem',
                    verticalAlign: 'middle',
                  }}
                >
                  <Btn onClick={localDispatch.onBtnLimparFiltroClick}>Limpar Filtro</Btn>
                </div>

                <div
                  style={{
                    display: 'inline-block',
                    marginRight: '0.5rem',
                    marginBottom: '0.5rem',
                    verticalAlign: 'middle',
                  }}
                >
                  <Btn
                    onClick={() =>
                      localDispatch.onBtnEmitirMapaClick(
                        state.fleets.filter(f => f.selected),
                        selectedTp,
                      )
                    }
                  >
                    Emitir Mapa de Carga
                  </Btn>
                </div>

                <div
                  style={{
                    display: 'inline-block',
                    marginRight: '0.5rem',
                    marginBottom: '0.5rem',
                    verticalAlign: 'middle',
                  }}
                >
                  <SplitButton
                    menuStyle={{ width: 250 }}
                    className="bck-primary"
                    label="01. Emitir Mapa de Entrega"
                    icon="pi pi-tags"
                    onClick={() =>
                      localDispatch.onBtnEmitirMapaEntregaClick(
                        state.fleets.filter(f => f.selected),
                        selectedTp,
                      )
                    }
                    model={splitButtonsItems}
                  />
                </div>

                <div
                  style={{
                    display: 'inline-block',
                    marginBottom: '0.5rem',
                    verticalAlign: 'middle',
                  }}
                >
                  <Btn
                    onClick={() =>
                      localDispatch.onBtnEmitirMapaCarregamentoEstoque(
                        state.fleets.filter(f => f.selected),
                        selectedTp,
                      )
                    }
                  >
                    Mapa de Carregamento - Estoque
                  </Btn>
                </div>
                {isRouteAllowed(48) && (
                  <div
                    style={{
                      display: 'inline-block',
                      marginLeft: '0.5rem',
                      marginBottom: '0.5rem',
                      verticalAlign: 'middle',
                    }}
                  >
                    <Btn
                      onClick={() =>
                        localDispatch.onBtnCancelarMapaEmitidoClick(
                          state.fleets.filter(f => f.selected),
                          selectedTp,
                        )
                      }
                    >
                      Cancelar Mapa de Carga
                    </Btn>
                  </div>
                )}
              </div>
            </div>
            <div className="p-col-12">
              <CustomCheckbox
                checked={state.selecionarTodos}
                onChange={() => localDispatch.onChangeSelecionarTodos(!state.selecionarTodos)}
              >
                Selecionar Todos
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.fleets}
                emptyMessage={'Nenhum veículo disponível para emissão do Mapa de Carga'}
                rows={15}
                header={header}
                paginator={true}
                globalFilter={state.globalFilter}
              >
                <Column
                  header={'#'}
                  body={item => (
                    <CustomCheckbox
                      checked={item.selected}
                      onChange={() => localDispatch.onItemClicked(item)}
                    />
                  )}
                  style={tableCellCentered(60)}
                />
                <Column
                  field={'expected_date'}
                  header={'Data Prevista'}
                  style={tableCellCentered(130)}
                  sortable
                  body={fleet => <DateTime>{fleet.expected_date}</DateTime>}
                />
                <Column field={'vehicle_badge'} header={'Placa'} />
                <Column
                  field={'mapa_emitido'}
                  header={'Mapa de Carga Emitido'}
                  style={tableCellCentered(200)}
                  body={fleet =>
                    fleet.mapa_emitido ? (
                      <div style={{ textAlign: 'center', color: 'green' }}>Sim</div>
                    ) : (
                      <div style={{ textAlign: 'center', color: 'red' }}>Não</div>
                    )
                  }
                />
                <Column
                  field={'qte_deliveries'}
                  header={'Qte Entregas'}
                  style={tableCellCentered(150)}
                />
                <Column
                  field={'qte_sku'}
                  header={'Qte SKUs'}
                  body={qteSkuBodyTemplate}
                  style={tableCellCentered(100)}
                />
                <Column field={'weight'} header={'Peso'} style={tableCellCentered(100)} />
                <Column
                  header={'Menu'}
                  style={tableCellCentered(80)}
                  body={fleet => (
                    <ThreeDots
                      items={['Ordem Carregamento', 'Observações']}
                      onClick={item => localDispatch.onMenuItemClick(item, fleet)}
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <OrdemCarregamentoModal
        visible={state.modal === 'Ordem Carregamento'}
        deliveries={
          state.selectedFleet && state.selectedFleet.deliveries
            ? state.selectedFleet.deliveries
            : []
        }
        onResponse={localDispatch.onModalResponse}
      />
      <ObservacoesModal
        visible={state.modal === 'Observações'}
        fleet={state.selectedFleet}
        onResponse={localDispatch.onModalResponse}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MapaCarga))
